import {APP_KEY, HTTP_URL, PHP_API_URL} from "../../../util/constants";
import request from "../../../util/request";
import Cookies from 'js-cookie';

export function getInfoListRequest(namekey,status,offset,limit,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'get_school_teacher_list');
  formData.append("school_code",Cookies.get("school_code"));
  formData.append("namekey",namekey);
  formData.append("status", status);//(不选传空字符串，1:正常 2：删除 3：禁用)
  formData.append("offset", offset);
  formData.append("limit", limit);


  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}










//获取学科列表
export function getXuekeListRequest(
    username,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'get_nianji_xueke_list');
  formData.append("username",username);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}



//添加学校用户
export function addSchoolTeacherRequest(
    name,
    user_login,
    pwd,
    jifen,
    status,
    beizhu,
    school_code,
    school_teacher_shenfen_json,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'add_school_teacher');
  formData.append("name",name);
  formData.append("user_login",user_login);
  formData.append("pwd",pwd);
  formData.append("jifen",jifen);
  formData.append("status",status);
  formData.append("beizhu",beizhu);
  formData.append("school_code",school_code);
  formData.append("school_teacher_shenfen_json",school_teacher_shenfen_json);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}

//添加学校用户
export function updateSchoolTeacherRequest(
    name,
    username,
    pwd,
    jifen,
    status,
    beizhu,
    school_code,
    school_teacher_shenfen_json,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'update_school_teacher');
  formData.append("name",name);
  formData.append("username",username);
  formData.append("pwd",pwd);
  formData.append("jifen",jifen);
  formData.append("status",status);
  formData.append("beizhu",beizhu);
  formData.append("school_code",school_code);
  formData.append("school_teacher_shenfen_json",school_teacher_shenfen_json);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}


//删除教师用户
export function deleteSchoolTeacherRequest(
    username,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'del_school_teacher');
  formData.append("username",username);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}


//修改教师账号状态
export function changeAdminStatusRequest(
    username,
    status,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'jinyong_qiyong_school_teacher');
  formData.append("username",username);
  formData.append("status",status);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}


//添加学校用户
export function editSchoolTeacherRequest(
    username,
    school_name,
    dizhi,
    pwd,
    name,
    teacher_num,
    status,
    beizhu,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'update_school_teacher');
  formData.append("username",username);
  formData.append("school_name",school_name);
  formData.append("dizhi",dizhi);
  formData.append("pwd",pwd);
  formData.append("name",name);
  formData.append("teacher_num",teacher_num);
  formData.append("status",status);
  formData.append("beizhu",beizhu);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}



